import { render, staticRenderFns } from "./modal-products-create-edit-form.vue?vue&type=template&id=08ea7d94&"
import script from "./modal-products-create-edit-form.vue?vue&type=script&lang=js&"
export * from "./modal-products-create-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports